import { ActivityCosts } from '@faro/study-designer-model';
import axios from 'axios';
import { ScheduleOfActivitiesQueryParameter, StudyPathParameter } from '../parameter';

export type ActivityCostsParameters = StudyPathParameter & ScheduleOfActivitiesQueryParameter;

export const activityCostsClient = {
    get(params: ActivityCostsParameters): Promise<ActivityCosts[]> {
        const { studyId, scheduleOfActivitiesId } = params;
        return axios
            .get(`/api/study-designer/studies/${studyId}/activity-costs`, {
                params: { scheduleOfActivitiesId },
            })
            .then(response => response.data);
    },
};
